import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getArticleList as getArticleListApi,
	getArticle as getArticleApi,
	addNewArticle as addNewArticleApi,
	updateArticle as updateArticleApi,
	deleteArticle as deleteArticleApi,
	getArticleMultiple as getArticleMultipleApi,
} from '../../helpers/normative/backend_helper';

export const getArticleList = createAsyncThunk('article/getArticleList', async (params) => {
	try {
		const response = getArticleListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getArticle = createAsyncThunk('article/getArticle', async article_id => {
	try {
		const response = getArticleApi(article_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getArticleMultiple = createAsyncThunk('article/getArticleMultiple', async (article_ids) => {
	try {
		const response = getArticleMultipleApi(article_ids);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewArticle = createAsyncThunk('article/addNewArticle', async article => {
	try {
		const response = addNewArticleApi(article);
		return response;
	} catch (error) {
		toast.error('Error al agregar compromiso.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateArticle = createAsyncThunk('article/updateArticle', async (article) => {
	try {
		const response = updateArticleApi(article);
		toast.success('Artículo actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar compromiso.', { autoClose: 3000 });
		throw new Error(error);
	}
}
);

export const deleteArticle = createAsyncThunk('article/deleteArticle', async article => {
	try {
		const response = await deleteArticleApi(article);
		toast.success('Artículo eliminado exitosamente.', { autoClose: 3000 });
		return { article, ...response };
	} catch (error) {
		toast.error('Error al eliminar compromiso.', { autoClose: 3000 });
		throw new Error(error);
	}
});

